import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropZone from 'UIComponents/drop/UIDropZone';
// @ts-expect-error not typed
import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
// @ts-expect-error not typed
import { getDndAreaCellElement } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { EMPTY_PLACEHOLDER_ID_PARTIAL } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LayoutSectionEmptyCellPlaceholder extends Component {
  constructor(...args) {
    super(...args);
    this.cellElement = null;
  }
  componentDidMount() {
    const {
      cellId
    } = this.props;
    this.getCellFromDOM(cellId);
  }
  componentDidUpdate(prevProps) {
    const {
      cellId
    } = this.props;
    if (prevProps.cellId !== cellId) {
      this.getCellFromDOM(cellId);
    }
  }
  componentWillUnmount() {
    this.cellElement = null;
  }
  getCellFromDOM(cellId) {
    this.cellElement = getDndAreaCellElement(cellId);
    return this.cellElement;
  }
  render() {
    const {
      cellId,
      layoutSectionId,
      isHovered
    } = this.props;

    // After a tree structure change we expect that the DOM may not have been updated yet.
    // So try again if needed, but bail silently if the DOM is still missing
    if (!this.cellElement && !this.getCellFromDOM(cellId)) {
      return null;
    }
    return /*#__PURE__*/_jsx(AfterBeginPortal, {
      id: `${EMPTY_PLACEHOLDER_ID_PARTIAL}-${layoutSectionId}-${cellId}`,
      namespace: NAMESPACE_CLASS,
      targetElement: this.cellElement,
      children: /*#__PURE__*/_jsx(UIDropZone, {
        className: "m-all-1",
        use: isHovered ? 'hover' : 'default',
        size: "sm",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.layoutSection.dropZone"
        })
      })
    });
  }
}
LayoutSectionEmptyCellPlaceholder.propTypes = {
  cellId: PropTypes.string.isRequired,
  layoutSectionId: PropTypes.string.isRequired,
  isHovered: PropTypes.bool.isRequired
};